module.exports = __webpack_public_path__ + "static/media/uberEats-3a.11e28df0.png";